import { combineReducers } from '@reduxjs/toolkit';
import appReducer from './appReducer';
import authReducer from './authReducer';
import mapSlice from '../slices/mapSlice';
import loading from './loading/loading.reducer';
import PREPPAREReducers from '../PREPAREsrc/store/rootReducers';

import ics_incident_infoReducer from '../slices/ics_incidentInfoSlice';
import ics_incident_resourcesReducer from '../slices/ics_incidentResourcesSlice';
import ics_resourceRequestsReducer from '../slices/ics_resourceRequestsSlice';
import ics_resourceRequestItemsReducer from '../slices/ics_resourceRequestItemsSlice';
import ics_work_assignmentsReducer from '../slices/ics_workAssignmentsSlice';
import ics_incident_work_assignmentsReducer from '../slices/ics_incidentWorkAssignmentsSlice';
import resourceSitesReducer from '../slices/ics_resourceSitesSlice';
import strikeTeamsReducer from '../slices/ics_strikeTeamsSlice';
import dchatReducer from '../slices/dchatSlice';
import notificationsReducer from '../slices/notificationsSlice';

const combinedReducers = combineReducers({
  app: appReducer,
  auth: authReducer,
  map: mapSlice.reducer,
  loading: loading,
  prepare: PREPPAREReducers,
  ics_incident_info: ics_incident_infoReducer,
  ics_incident_resources: ics_incident_resourcesReducer,
  ics_resource_requests: ics_resourceRequestsReducer,
  ics_resource_request_items: ics_resourceRequestItemsReducer,
  ics_work_assignments: ics_work_assignmentsReducer,
  ics_incident_work_assignments: ics_incident_work_assignmentsReducer,
  ics_resource_sites: resourceSitesReducer,
  ics_strike_teams: strikeTeamsReducer,
  dchat: dchatReducer,
  notifications: notificationsReducer,
});

export default combinedReducers;
export type RootState = ReturnType<typeof combinedReducers>;
